var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-arrow",class:_vm.direction,on:{"click":_vm.handleClick}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.arrow)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }